import React, { useEffect, useState } from "react";
import { StyledHeader } from "./ClubFinancial";
import LabelText from "../../../ui/LabelText";
import { IcashCredit, Idebts } from "../../../types/IClubDetail";
import SeasonBreakdownBarChart from "../../PlayerDetail/Attributes/SeasonBreakdownBarChart";
import { IRingData } from "../../../types/IPlayerDetail";

interface CashCreditDebtProps {
  data: IcashCredit;
  debtsData: Idebts;
}

const CashCreditDebt: React.FC<CashCreditDebtProps> = ({ data, debtsData }) => {
  const [cashCreditData, setCashCrediData] = useState<IRingData[]>([]);
  const [debtData, setDebtData] = useState<IRingData[]>([]);

  useEffect(() => {
    setDebtData([
      { name: "short term debt", percent: debtsData?.shortTermDebt, valueText: debtsData?.shortTermDebtText, color: "#00D1A8" },
      { name: "long term debt", percent: debtsData?.longTermDebt, valueText: debtsData?.longTermDebtText, color: "#FF7800" },
    ]);
  }, [debtsData]);

  useEffect(() => {
    setCashCrediData([
      { name: "short term credit", percent: data?.shortTermCredit, valueText: data?.shortTermCreditText, color: "#00D1A8" },
      { name: "long term credit", percent: data?.longTermCredit, valueText: data?.longTermCreditText, color: "#FF7800" },
      { name: "Cash & cash equivalents", percent: data?.cashEquivalents, valueText: data?.cashEquivalentsText, color: "#FFC2C2" },
    ]);
  }, [data]);

  return (
    <>
      <div className="flex-chart-container">
        <div className="flex-chart-container-wrapper">
          <StyledHeader className="header-content">
            <LabelText className="drawer-title">Cash & credit</LabelText>
          </StyledHeader>
          <SeasonBreakdownBarChart data={cashCreditData} isFlex={true} />
          {/* <DonutRingChart data={donutRingData} total={data?.totalAssetsText} type="assets"/> */}
        </div>
        <div className="flex-chart-container-wrapper">
          <StyledHeader className="header-content">
            <LabelText className="player-family-name">Debt</LabelText>
          </StyledHeader>
          <SeasonBreakdownBarChart data={debtData} isFlex={true} />
        </div>
      </div>
    </>
  );
};

export default CashCreditDebt;
